import { styled } from '@mui/material/styles';
import { TextInput } from 'react-admin';

export const TextInputStyled = styled(TextInput)({
  overflow: 'visible',
});
